import React, {memo} from 'react';
import {ModuleTabularPage} from "../../components";
import {AdminModules, AdminReqUrls} from "../../config/AdminConfig";

const CsPage = memo(() => {
    return (<ModuleTabularPage
        moduleName={AdminModules.CS}
        fetchRecordsUrl={AdminReqUrls.admin__cs__mainPage_fetch_recordList}
    />)
});
export default CsPage;
